class AnimatedTabSection {
    #animatedTabSection: HTMLElement;
    #tabObserver: MutationObserver;

    constructor(el: HTMLElement) {
        this.#animatedTabSection = el;
        this.#tabObserver = new MutationObserver(() => {
            this.#animateEls();
        });
    }

    addObservers() {
        for (const tab of this.#animatedTabSection.querySelectorAll('[data-ats-tab]')) {
            this.#tabObserver.observe(tab, { attributeFilter: ['aria-selected'] });
        }
    }

    #animateEls() {
        const panels = this.#animatedTabSection.querySelectorAll(
            "[id^='three-tab-section-panel']"
        );
        for (const panel of panels) {
            const elsToAnimate = panel.querySelectorAll(
                '[data-tab-change-animation-play]'
            );

            if (elsToAnimate) {
                if (panel.hasAttribute('hidden')) {
                    elsToAnimate.forEach(elToAnimate => {
                        elToAnimate.setAttribute('data-tab-change-animation-play', 'off');
                    });
                } else {
                    elsToAnimate.forEach(elToAnimate => {
                        const timeoutToBypassDisplayNone = setTimeout(() => {
                            elToAnimate.setAttribute(
                                'data-tab-change-animation-play',
                                'on'
                            );
                            clearTimeout(timeoutToBypassDisplayNone);
                        }, 10);
                    });
                }
            }
        }
    }
}
export default function animatedTabSection(animatedTabSectionEls: HTMLElement[]) {
    animatedTabSectionEls.forEach(sectionEl => {
        const ats = new AnimatedTabSection(sectionEl);
        ats.addObservers();
    });
}
